import React, { useEffect } from 'react'
import Container from '../container/Container'
import Header from 'components/header/pageHeader/Header'
import { PROVABLY_PROPS } from './interfaces'
import ProvablySeedForm from './ProvablySeeds/ProvablySeedForm'
import ProvablySeedPair from './ProvablySeeds/ProvablySeedPairs'
import ExplanationContent from './ProvablyDetails/ExpBlock'

import UseProvablySeeds from './helperFunctions/UseProvablySeeds'
import { Main } from './ProvFairStyled'
import Verifier from './ProvablySeeds/Verifier'
import { SFXS } from 'index'

export default function ProvablyFair({
  colors,
  handleAbove,
  seeds,
  seedRequest,
  newSeedRequest,
  handleNotification,
  audio,
  roundIsOn,
  verifierFunc,
}: PROVABLY_PROPS) {
  const { CurrentSeedPair, PreviousSeedPair } = UseProvablySeeds(seeds)

  useEffect(() => {
    seedRequest()
  }, [])

  return (
    <Container unBlur={false} backgroundColor={colors.primary}>
      <Header
        name='Prov. Fair'
        handleAbove={handleAbove}
        textColor={colors.secondary}
        background={colors.secondary}
        borderColor={colors.secondary}
        strokeColor={colors.tertiary}
        audio={audio}
      />
      <Main>
        <ProvablySeedPair
          pf={CurrentSeedPair}
          colors={colors}
          handleNotification={handleNotification}
        />
        <ProvablySeedForm
          sendSeed={newSeedRequest}
          colors={colors}
          handleNotification={handleNotification}
          audio={audio}
          roundIsOn={roundIsOn}
        />
        <h2>Previous seed pair</h2>
        <ProvablySeedPair
          pf={PreviousSeedPair}
          colors={colors}
          handleNotification={handleNotification}
        />
        <Verifier
          colors={colors}
          func={verifierFunc}
          SFXS={SFXS}
          PreviousSeedPair={PreviousSeedPair}
        />
        <ExplanationContent colors={colors} />
      </Main>
    </Container>
  )
}
